// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"d6e56334","141":"cb2aa3fa","219":"7cfccb23","308":"eec5063b","329":"a94e3bed","378":"a6f747c6","434":"a20b61fa","453":"655a8d83","465":"788b9544","672":"90461f05","681":"50c7def1","795":"4e594862","889":"2ea69eb4","972":"9113e067"}[chunkId] + ".chunk.js";
};